// Pure published-uniform resolution. Never accept arbitrary SVG, URLs or draft assets.
const HEX = /^#[0-9a-fA-F]{6}$/;
const ID = /^uniform_[a-z0-9]+(?:_[a-z0-9]+)*$/;
const TEMPLATES = new Set(['scrub-vneck-v1', 'healthcare-tunic-v1']);
const BADGES = new Set(['nhs-standard', 'none']);
const object = value => value && typeof value === 'object' && !Array.isArray(value) ? value : {};

export function validPublishedUniform(value, id) {
  const item = object(value);
  return Boolean(ID.test(id || '') && item.id === id && typeof item.name === 'string' && item.name.trim() && item.name.length <= 120 && TEMPLATES.has(item.templateId) && HEX.test(item.bodyHex || '') && HEX.test(item.trimHex || '') && (item.pocketPipingHex == null || HEX.test(item.pocketPipingHex)) && BADGES.has(item.badge?.assetId) && typeof item.badge?.visible === 'boolean');
}

export function resolvePublishedUniform(configuration, id) {
  if (!configuration || !id || !Object.prototype.hasOwnProperty.call(object(configuration.uniforms), id)) return null;
  const item = configuration.uniforms[id];
  if (!validPublishedUniform(item, id)) return null;
  const badge = item.badge;
  const name = item.name.trim();
  return {
    id, token: id, uniformDefinitionId: id, templateId: item.templateId,
    label: name, short_label: name, description: name, accessibilityLabel: name,
    body_hex: item.bodyHex.toUpperCase(), trim_hex: item.trimHex.toUpperCase(),
    pocketPipingHex: item.pocketPipingHex ? item.pocketPipingHex.toUpperCase() : null,
    pattern: item.bodyHex.toUpperCase() === item.trimHex.toUpperCase() ? 'solid' : 'contrast-trim',
    badge: { assetId: badge.assetId, visible: badge.assetId !== 'none' && badge.visible },
    garmentId: 'tunic',
  };
}

export function resolvePublishedRoleUniform(configuration, localUniform) {
  const local = object(localUniform);
  return resolvePublishedUniform(configuration, local.uniformDefinitionId);
}

export function publishedUniformOptions(configuration, legacyOptions = []) {
  if (!configuration) return legacyOptions;
  const used = new Set(Object.values(object(configuration.roles)).filter(role => role?.included !== false).map(role => role?.uniform?.uniformDefinitionId).filter(Boolean));
  const custom = [...used].map(id => resolvePublishedUniform(configuration, id)).filter(Boolean);
  const existing = new Set(legacyOptions.map(item => item.id));
  return [...legacyOptions, ...custom.filter(item => !existing.has(item.id))];
}

export function getActiveUniformTrustId() {
  if (typeof window === 'undefined') return 'generic_nhs';
  try { return window.localStorage.getItem('myhealthcareteam_selected_hospital') || 'generic_nhs'; }
  catch { return 'generic_nhs'; }
}
